import variables from "./varialbles";

const prospectBreadCrum = "Prospect Manager";
const onboardingBreadCrum = "Onboarding Manager";
const investmentBreadCrum = "Investor Manager";
const vantageBreadCrum = "Synapse";
const referralManagerBreadCrum = "Referral Manager";
const brokerManagerBreadCrum = "Broker Manager";
const lookupManagerBreadcrum = "Lookup Manager";
const userManagementBreadcrum = "User Management";
const profileBreadcrum = "Profile";
const beigemBreadcrum = "Beige - Event Management";
const contentManagementBreadcrum = "Content Management";
const viewInternalSupportBreadcrum = "Internal Support";
const callRequestsBreadcrum = "Call Requests";
const misReportBreadcrum = "MIS Report";
const adviceRequestBreadcrum = "Research Dashboard";
const RequesttoPayBreadcrum = "Request To Pay";
const notesReviewBreadcrum = "Notes";
const createfranchiseBreadcrum = "Create URL";
const bulkUploadBreadcrum = "Bulk Upload";

// internal support path's
const InternalSupport = [
  variables.viewInternalSupportPath,
  variables.addInternalSupportPath,
  variables.editInternalSupportPath,
];

// call request path's
const CallRequest = [variables.callRequestsTabsPath];

// Bulk Upload path
const BulkUpload = [variables.uploadecxel];

const createfranchisePaths = [variables.createfranchisepath];

// MIS Reports Path's
const misReports = [
  variables.viewMitsReportsPath,
  variables.viewMitsChildReportsPath,
  variables.ViewNestedChildMisReportsPath,
  variables.stockWiseReportsPath,
  variables.viewResearchReportsPath,
  variables.viewSalesReportsPath,
  variables.ViewCdtReportsPath,
  variables.goalAdvicesStopped,
];

// prospect manager path's
const prospectPaths = [
  variables.prospectPath,
  variables.prospectDetailsPath,
  variables.communicatioTimeLinePath,
  variables.addCommunicatioTimeLinePath,
  variables.activityLogPath,
  variables.investmentProfilePath,
  variables.personalProfilePath,
  variables.prospectSatisfactionPath,
  variables.addReviewPath,
  variables.referralDashboardPath,
  variables.addProspectPath,
  variables.addTicketPath,
  variables.addPaymentPath,
  variables.addDiscountPath,
  variables.editProspectPath,
  variables.createNotificationPath,
  variables.createEmailPath,
  variables.prospectGoalsDashboardPath,
  variables.editTicketPath,
  variables.franchiseDashboard,
  variables.reassignRmList,
];

// Investment manager path's
const investmentPaths = [
  variables.investmentPath,
  variables.investmentsPath,
  // variables.investmentDetailsPath,
  variables.subscriptionManagerPath,
  variables.addCommunicatioTimeLinePath,
  variables.activityLogPath,
  variables.investmentProfilePath,
  variables.personalProfilePath,
  variables.investmentSatisfactionPath,
  variables.addReviewPath,
  variables.referralDashboardPath,
  variables.investmentPersonalProfilePath,
  variables.investorInvestmentProfilePath,
  variables.investmentAddPaymentPath,
  variables.investmentDiscountPath,
  variables.investmentReferalDashboardPath,
  variables.investorActivityLogPath,
  variables.investmentAdvicePath,
  variables.investorPortFolioPath,
  variables.editInvestorQuestioner,
  variables.goalsDashboardPath,
  variables.investorcommunicationTimeLinePath,
  variables.investorAddCommunicatioTimeLinePath,
  variables.investorCreateNotificationPath,
  variables.investorCreateEmailPath,
  variables.addInvestorReviewPath,
  variables.investorNotifiCationManagerPath,
  variables.investorindividualRequestPath,
  variables.editInvestPath,
  variables.delrequestspath,
];
// vantage path's
const vantagePaths = [
  variables.vantagePath,
  variables.addInvestmentPath,
  variables.editInvestmentPath,
  variables.addTheme,
  variables.addEFG,
  variables.editEFG,
];
// Referral Dashboard path's
const referralManagerPaths = [
  variables.referralManagerPath,
  variables.referralDashboardOverViewPath,
];
// lookup manager path's
const lookUpPaths = [
  variables.lookupManagerPath,
  variables.addLookupManagerPath,
  variables.lookUpPath,
];
const callRequestsPaths = [variables.callRequestsPath];
const adviceRequestPaths = [
  variables.adviceRequestsPath,
  variables.createAdviseRequestPath,
  variables.manualAdviceTabsPath,
];
const brokerManagerPaths = [variables.brokerManagerPath];
const contentManagementPaths = [
  variables.contentManagementPath,
  variables.addContentManagementPath,
];
// user management path's
const userManagementPaths = [
  variables.userManagementPath,
  variables.editUserPath,
];

const profilePaths = [variables.myPerformancePath];

const beigePaths = [
  variables.beigeManagementPath,
  variables.addDiscountOverAllPath,
  variables.addNotificationPath,
];
const cmsPaths = [
  variables.contentManagementPath,
  variables.addContentManagementPath,
  variables.editContentManagementPath,
];

const razorpyPath = [variables.razorpyPath];

const notes = [variables.notesReview];

// Onboarding path
const Onboarding = [variables.onboardingoverviewPath];

const getBreadCrum = (path) => {
  if (prospectPaths.indexOf(path) !== -1) {
    return prospectBreadCrum;
  } else if (investmentPaths.indexOf(path) !== -1) {
    return investmentBreadCrum;
  } else if (vantagePaths.indexOf(path) !== -1) {
    return vantageBreadCrum;
  } else if (referralManagerPaths.indexOf(path) !== -1) {
    return referralManagerBreadCrum;
  } else if (brokerManagerPaths.indexOf(path) !== -1) {
    return brokerManagerBreadCrum;
  } else if (lookUpPaths.indexOf(path) !== -1) {
    return lookupManagerBreadcrum;
  } else if (userManagementPaths.indexOf(path) !== -1) {
    return userManagementBreadcrum;
  } else if (profilePaths.indexOf(path) !== -1) {
    return profileBreadcrum;
  } else if (beigePaths.indexOf(path) !== -1) {
    return beigemBreadcrum;
  } else if (cmsPaths.indexOf(path) !== -1) {
    return contentManagementBreadcrum;
  } else if (InternalSupport.indexOf(path) !== -1) {
    return viewInternalSupportBreadcrum;
  } else if (CallRequest.indexOf(path) !== -1) {
    return callRequestsBreadcrum;
  } else if (misReports.indexOf(path) !== -1) {
    return misReportBreadcrum;
  } else if (adviceRequestPaths.indexOf(path) !== -1) {
    return adviceRequestBreadcrum;
  } else if (razorpyPath.indexOf(path) !== -1) {
    return RequesttoPayBreadcrum;
  } else if (createfranchisePaths.indexOf(path) !== -1) {
    return createfranchiseBreadcrum;
  } else if (notes.indexOf(path) !== -1) {
    return notesReviewBreadcrum;
  } else if (BulkUpload.indexOf(path) !== -1) {
    return bulkUploadBreadcrum;
  } else if (Onboarding.indexOf(path) !== -1) {
    return onboardingBreadCrum;
  } else {
    return "";
  }
};

export default getBreadCrum;
